import React from 'react';
import {components, GroupBase, OptionProps} from 'react-select';
import {IQuestionAnswerType} from '../../../../incase-domain/elements/base/questionElementBase';

function MultiSelectOption(
    props: OptionProps<
        {value: string; label: string; type?: IQuestionAnswerType},
        true,
        GroupBase<{value: string; label: string; type?: IQuestionAnswerType}>
    >
): JSX.Element {
    const {isSelected, label} = props;

    return (
        <div className={`${isSelected && 'is-selected'}`}>
            <components.Option {...props}>
                <div className="c-check--scalable u-flex u-v-center">
                    <input type="checkbox" checked={isSelected} readOnly />
                    <label className="u-pointer">{label}</label>
                </div>
            </components.Option>
        </div>
    );
}

export default MultiSelectOption;
